import qs from 'query-string';

import { verifyFormExists } from '../../api/forms';
import { SPECIAL_CHARS } from '../../constants/Common';
import { isNilOrEmpty } from '../../utils/ramdaUtils';
import { WORKFLOW_CLIENT_WITH_STEP_ENTITY_FORM_TYPE } from '../constants/new-forms.constants';

export const validateNewFormProp = ({ propValue = '' }) => {
  const error = {};
  if (isNilOrEmpty(propValue)) {
    error.hasError = true;
    error.errorText = 'This field is required';
  } else if (propValue !== 'entity' && SPECIAL_CHARS.test(propValue)) {
    error.hasError = true;
    error.errorText = 'This field supports only alphanumeric and underscore (_) characters';
  } else {
    error.hasError = false;
    error.errorText = '';
  }
  return error;
};

export const validateNewFormModalOnBlur = ({ formSettings, propName, modalErrors }) => {
  const errors = { ...modalErrors };
  const propError = validateNewFormProp({ propValue: formSettings[propName] });
  errors[propName] = { ...propError };
  return errors;
};

export const validateNewFormModalOnCreate = async ({ formType, formName, entity, subEntity }) => {
  const errors = {
    formName: {},
    entity: {},
    subEntity: {},
  };

  if (!formName.length) {
    errors.formName.hasError = true;
    errors.formName.errorText = 'This field is required';
  }

  if (!entity.length) {
    errors.entity.hasError = true;
    errors.entity.errorText = 'This field is required';
  }

  if (formType === WORKFLOW_CLIENT_WITH_STEP_ENTITY_FORM_TYPE && !subEntity.length) {
    errors.subEntity.hasError = true;
    errors.subEntity.errorText = 'This field is required';
  }

  if (errors.formName.hasError || errors.entity.hasError || errors.subEntity.hasError) {
    return errors;
  }

  const isFormExist = await verifyFormExists({ formKey: formName });

  if (isFormExist) {
    errors.formName.hasError = true;
    errors.formName.errorText = 'This form already exists';
  }

  return errors;
};

export const getNewFormLink = ({ formName, entity, subEntity }) => {
  const newFormParams = {
    orgCode: '',
    formKey: formName,
    formEntity: entity,
    formStyle: 'ClientEnableForm',
    formSubEntity: subEntity,
    isCreateForm: true,
    standaloneLayout: true,
  };
  const stringifyParams = qs.stringify(newFormParams);

  return `form-editor?${stringifyParams}`;
};
